import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, MessageSquare, Target, Zap, HelpCircle } from 'lucide-react';
const fadeIn = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6
    }
  }
};
export function Bonus() {
  const [openFaq, setOpenFaq] = useState<number | null>(0);
  const faqs = [{
    q: 'No tengo experiencia previa',
    a: 'El curso está diseñado exactamente para eso. Empezamos desde cero, con técnica real desde el primer día.'
  }, {
    q: '¿Vale la pena en Paysandú? ¿Hay mercado?',
    a: 'Avril vive de esto en Paysandú hace años. El mercado existe. Lo que falta son profesionales que hagan bien su trabajo.'
  }, {
    q: 'Ya vi tutoriales y no me resultó',
    a: 'Los tutoriales no te corrigen. Avril sí. Esa diferencia lo cambia todo.'
  }, {
    q: '¿Y si no me sale bien?',
    a: 'Por eso el curso tiene acompañamiento real, no solo videos. Estás con alguien que quiere que te vaya bien.'
  }, {
    q: '¿Es muy caro?',
    a: 'Comparalo con seguir cobrando barato, perder clientas o gastar en materiales que no funcionan. El curso se paga solo con tus primeras clientas bien cobradas.'
  }];
  const oneLiners = ['Las uñas que ponés son tu currículum. ¿Qué están diciendo?', 'No es el gel. No es la clienta. Es la técnica.', 'Cobrar barato no te hace accesible. Te hace invisible.', 'Cada uña que dura 21 días es un turno nuevo garantizado.', 'Las clientas no vuelven por el precio. Vuelven por la confianza.', 'Aprender bien una vez es más barato que equivocarse para siempre.', 'Tu agenda llena no va a aparecer sola. Aparece cuando sabés lo que hacés.', 'No necesitás Montevideo. Necesitás el método correcto.', 'La manicurista que cobra bien no nació sabiendo más. Le enseñaron mejor.', 'Un curso con Avril no es un gasto. Es el primer turno de tu nueva vida.'];
  return <div className="bg-brand-cream py-24 border-t border-brand-blush/30" data-id="element-4">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-5">
        {/* FAQ */}
        <motion.section initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} variants={fadeIn} className="mb-24 max-w-3xl mx-auto" data-id="element-6">
          <div className="flex items-center gap-3 mb-8" data-id="element-7">
            <HelpCircle className="text-brand-gold" data-id="element-8" />
            <h3 className="text-2xl font-serif text-brand-charcoal" data-id="element-9">
              Preguntas Frecuentes
            </h3>
          </div>

          <div className="space-y-4" data-id="element-10">
            {faqs.map((faq, index) => <div key={index} className="bg-brand-ivory rounded-2xl border border-brand-blush/30 overflow-hidden" data-id="element-11">
                <button onClick={() => setOpenFaq(openFaq === index ? null : index)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-12">
                  <span className="font-medium text-brand-charcoal pr-8" data-id="element-13">
                    {faq.q}
                  </span>
                  <ChevronDown className={`text-brand-gold transition-transform duration-300 flex-shrink-0 ${openFaq === index ? 'rotate-180' : ''}`} data-id="element-14" />
                </button>
                <AnimatePresence data-id="element-15">
                  {openFaq === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-16">
                      <div className="px-6 pb-5 text-brand-charcoal/70 border-t border-brand-cream pt-4" data-id="element-17">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>)}
          </div>
        </motion.section>
      </div>
    </div>;
}